/*
MODIFICATION PROVIDED BY THE SEARCHANISE TEAM, WITH ANY QUESTIONS, CONTACT US AT feedback@searchanise.io

The modification replaces the search suggestions in the Instant search widget to the ones defined in the customSuggestions list.

Please note that the max number of the search suggestions are defined in the app admin panel > Search & Navigation > Instant search widget > Content tab > Suggestion qty. option 

You can manually change the suggestion terms. You can remove the existing ones and add new terms. 

Please be sure to follow the formating rules to ensure the correct work:

1. Suggestions should be put inside customSuggestions variable square brackets []
2. Each suggestion should be put inside quote marks
3. Suggestions should be divided by a comma 

Here is a reference:

let customSuggestions = ["first term", "second term", "third term"];

To quickly disable the modification, change the isEnabled value from true to false, so it looks like that:

let isEnabled = false;

*/

// SETTINGS START

let customSuggestions = ["Electrified Exit Devices", "Cylindrical Lever Locks", "Keypad Cylindrical Locks", "Rim Exit Devices", "Mortise Locks"];

let isEnabled = true;

// SETTINGS END. DON'T EDIT THE CODE BELOW

document.addEventListener('Searchanise.Loaded', function() {
    (function($) {

        if (!isEnabled || isEnabled === 'false') { return }

        let iswSuggestionsQty = Searchanise.GetWidgets().options.AutocompleteSuggestionCount;

        $(document).on('Searchanise.AutocompleteUpdated', function(event, input, container) {
            if (customSuggestions && customSuggestions.length && $('#snize-ac-items-container-1').length) {
                $('#snize-ac-items-container-1 .snize-suggestion').remove();
                for (let i = 0; i < iswSuggestionsQty; i++) {
                    let oddOrEven = i % 2 ? 'even' : 'odd';
                    $('#snize-ac-items-container-1').append(`<li tabindex="0" class="snize-suggestion snize-ac-${oddOrEven}" aria-label="${customSuggestions[i]}" id="snize-suggestion-i" role="option" style="cursor: pointer;">${customSuggestions[i]}</li>`)
                }
            }
            if (customSuggestions && customSuggestions.length && $('.snize-nothing-found').length) {
                $('.snize-no-products-found-link', container).remove();
                for (let suggestion of customSuggestions) {
                    $('.snize-popular-suggestions-container', container).append(`<a class="snize-no-products-found-link" href="#" data-no-instant="true">${suggestion}</a>`);
                }
            }
        });
    })(window.Searchanise.$);
});